<template>
  <base-modal>
    {{ $t('pbx.service-package.modal.change_time.content') }}

    <i-button
      slot="footer-cancel"
      size="large"
      :disabled="loading"
      :loading="loading_deferred"
      @click="change('deferred')"
    >
      {{ $t('pbx.service-package.modal.change_time.buttons.deferred', { date: tariff_end }) }}
    </i-button>

    <i-button
      slot="footer-ok"
      size="large"
      type="primary"
      :disabled="loading"
      :loading="loading_immediate"
      @click="change('immediate')"
    >
      {{ $t('pbx.service-package.modal.change_time.buttons.immediate') }}
    </i-button>
  </base-modal>
</template>

<script>
  import { PageServerValidationResponseMixin } from '@shared/mixins/page-server-validation-response';
  import BaseModal from '@shared/components/modal/modal';
  import { UserService } from '@core/services/UserService';
  import { mapActions } from 'vuex';

  export default {
    components: {
      BaseModal
    },
    mixins: [PageServerValidationResponseMixin],
    props: {
      tariff_end: {
        type: String,
        default: ''
      },

      tariff: {
        type: Object,
        default: () => ({})
      }
    },

    data: () => ({
      loading_immediate: false,
      loading_deferred: false
    }),

    computed: {
      loading: function () {
        return this.loading_immediate || this.loading_deferred;
      }
    },

    methods: {
      ...mapActions('core/auth', ['syncOnlyUserProfile']),

      change: function (type) {
        this.loading_immediate = type === 'immediate';
        this.loading_deferred = type === 'deferred';

        UserService.changeServicePackage(this.$user.id, {
          type: type,
          package_id: this.tariff.id
        })
          .then(async () => {
            await this.syncOnlyUserProfile();
            this.$emit('success', { package_id: this.tariff.id });
          })
          .catch((e) => this.check_server_validation(e))
          .finally(() => {
            this.loading_immediate = false;
            this.loading_deferred = false;
          });
      }
    }
  };
</script>
